<template lang="pug">
  div
    .home__unit.media.media--center(
      :class="{'home__unit--off': !device.power, 'home__unit--error': deviceFail}")

      //- Icono
      van-icon.media__figure(
        :name="GetDeviceIcon(device, ACSMode)"
        @click="goToDevice()")
        .home__unit__master(v-if="device.master")

      //- Datos del dispositivo
      .media__body(@click="goToDevice()")
        .home__unit__name {{ device.name }}
        .home__unit__data(v-if="!loading")
          //- Temperatura local
          span(v-if="!ACSMode" :class="{'errorTemp': device.tsensor_error}")
            van-icon(name="temp")
            span(v-if="isNaN(localTemp)") --
            span(v-else) {{ localTemp }}
            span.unitType {{ tempUnit }}
          //- Setpoint
          span(v-if="!deviceFail")
            van-icon(name="thermometer" v-if="ACSMode")
            van-icon.margin-halve-left(:name="GetModeIcon(device.mode)" v-else)
            span(v-if="ACSMode") {{ device.acs_temp }}
            span(v-if="!ACSMode && device.mode !== MODES.FAN && device.mode !== MODES.DRY") {{ getSetPoint }}
            span.unitType(v-if="device.mode !== MODES.FAN && device.mode !== MODES.DRY") {{ tempUnit }}
          //- Dispositivo Vinculado a un tercero
          span(v-if="!deviceFail && device.link_deviceID")
            van-icon.margin-halve-left(name="device")
          //- Dispositivo Bloqueado
          span(v-if="!deviceFail && blockDevice")
            van-icon.margin-halve-left(name="key")

      //- Emergency Heat
      .media__emergencyHeat(
        v-if="emergencyHeatActivated && !deviceFail && !loading")
        div.media__warnings--icon
          van-icon(name="emer-heat")

      //- Avisos
        v-if="digitalInputActivated && !loading"
      .media__warnings(
        v-if="digitalInputActivated && !deviceFail && !loading"
        @click="showWarning(digitalInputActivated)")
        div.media__warnings--icon
          van-icon(name="stop")

      //- Botones
      .media__buttons(v-if="!deviceFail")
        button.powerOff(
          v-if="!ACSMode"
          :class="{'powerOff--select': device.power, 'unitTransparent': device.block_off || fallback}"
          @click="swithOff")
        button.powerOn(
          v-if="!ACSMode"
          :class="{'powerOn--select': device.power, 'unitTransparent': device.block_on || fallback}"
          @click="switchOn")
        button.powerful(
          v-if="ACSMode"
          :class="{'powerful--select': device.power_hot_water}"
          @click="switchPowerful")
          van-icon(name="powerful")

      //- Errores
        v-if="deviceFail && !loading && !digitalInputActivated" // Estado previo a mostrar errores con entradas digitales activadas
      .media__errors(
        v-if="deviceFail && !loading"
        @click="$emit('showInfo', {installationID, mac })")
        div.media__errors--icon
          | {{ deviceFail }}
          van-icon(name="info")

      //- Loading
      .media__errors(v-if="loading")
        div.media__errors--loading(v-if="loading")
          van-loading(type="spinner")

      //- Modal con los avisos
      van-popup.unit__webserver__popup(v-model="showDeviceWarning")
        DeviceModalWarning(
          v-if="showDeviceWarning"
          :unitWarning="warningDigitalInputActivated"
          @close="hideWarning()")

</template>

<script>
import Unit from '@/mixins/Unit.mixin';
import GetDeviceIcon from '@/mixins/GetDeviceIcon.mixin';
import GetModeIcon from '@/mixins/GetModeIcon.mixin';
import { MODES } from '@/app.config';
import DeviceModalWarning from '@/components/DeviceModalWarning.vue';

export default {
  mixins: [Unit, GetDeviceIcon, GetModeIcon],
  components: { DeviceModalWarning },
  data() {
    return {
      MODES,
      showDeviceWarning: false,
      warningDigitalInputActivated: null,
    };
  },
  props: {
    /**
     * Mac del dispositivo
     */
    mac: {
      type: String,
      required: true,
    },
    /**
     * ID de la instalación a la que pertenece el dispositivo
     */
    installationID: {
      type: String,
      required: true,
    },
    /**
     * Indica si se visualiza la línea como ACS
     */
    ACSMode: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /**
     * Redirige a la vista para manejar un dispositivo
     *
     * 1- Si el dispositivo tiene algún error no se podrá redireccionar a la vista
     */
    // eslint-disable-next-line consistent-return
    goToDevice() {
      if (this.deviceFail) return false; // - [1]

      const installationID = this.installationID;
      const mac = this.mac;
      const ACSMode = this.ACSMode;
      this.$router.push({ name: 'unit', params: { installationID, mac, ACSMode } });
    },

    /**
     * Muestra un modal con los avisos del dispositivo
     *
     */
    showWarning(data) {
      console.log('showWarning: ', data);
      this.warningDigitalInputActivated = data;
      this.showDeviceWarning = true;
    },

    /**
     * Oculta un modal con los avisos del dispositivo
     *
     */
    hideWarning() {
      this.showDeviceWarning = false;
    },
  },

  created() {
    console.log('DeviceRow (this): ', this);
  },
};
</script>
